(function() {
    var mq = window.matchMedia("(max-width: 75em)");
    var nav = document.getElementById("site-nav");
    if (!nav) return;
    if (mq.matches) {
        nav.classList.add("is-drawer");
        document.body.appendChild(nav);
        var headerRight = document.querySelector(".site-header__right");
        var lang = headerRight && headerRight.querySelector(".site-header__lang");
        if (lang) {
            var foot = document.createElement("div");
            foot.className = "site-header__drawer-foot";
            foot.appendChild(lang);
            nav.appendChild(foot);
        }
    }
})();

//# sourceMappingURL=corporate-site.d1f6182e.js.map
